import { apiCall } from "../api";
import ProgramListDto from "../../DTOs/Program/ProgramListDto";

const baseUrl = "applicationuserprogram";

export const getProgramsForUser = async (userId) => {
    let url = `${baseUrl}/${userId}`;
    let response = await apiCall(url);

    return new ProgramListDto(response.result);
}

export const updateProgramStaffAssignments = async (applicationUserProgramDto) => {
    let url = `${baseUrl}/update`;
    let response = await apiCall(url, { method: 'PUT', body: applicationUserProgramDto })

    return response.result;
}
